/**
 * Confidence UI Helpers
 * Pure functions for confidence score visualization
 */

export type ConfidenceLevel = 'very-high' | 'high' | 'moderate' | 'low';

export interface ConfidenceTheme {
  color: string;
  text: string;
  level: ConfidenceLevel;
}

/**
 * Get confidence color class for progress bars and badges
 */
export const getConfidenceColor = (confidence: number): string => {
  if (confidence >= 80) return "bg-red-500";
  if (confidence >= 60) return "bg-orange-500";
  if (confidence >= 40) return "bg-yellow-500";
  return "bg-green-500";
};

/**
 * Get human-readable confidence level text
 */
export const getConfidenceText = (confidence: number): string => {
  if (confidence >= 80) return "Very High";
  if (confidence >= 60) return "High";
  if (confidence >= 40) return "Moderate";
  return "Low";
};

/**
 * Get complete confidence theme for a score
 */
export const getConfidenceTheme = (confidence: number): ConfidenceTheme => {
  if (confidence >= 80) {
    return { color: "bg-red-500", text: "Very High", level: 'very-high' };
  }
  if (confidence >= 60) {
    return { color: "bg-orange-500", text: "High", level: 'high' };
  }
  if (confidence >= 40) {
    return { color: "bg-yellow-500", text: "Moderate", level: 'moderate' };
  }
  return { color: "bg-green-500", text: "Low", level: 'low' };
};
